import React, { Component } from 'react';
import PropTypes from 'prop-types';
import s from './OccupancyDates.module.scss';

class OccupancyDates extends Component {
    static propTypes = {
        closeDate: PropTypes.number,
        name: PropTypes.string,
        openDate: PropTypes.number,
        unoccupied: PropTypes.bool,
    };

    static defaultProps = {
        closeDate: Date.now(),
        name: 'Unoccupied',
        openDate: Date.now(),
        unoccupied: true,
    };

    unoccupiedLocation = () => {
        const { openDate, closeDate } = this.props;
        const open = new Date(openDate).toDateString();
        const close = new Date(closeDate).toDateString();
        return (
            <React.Fragment>
                <div className={s.title}> Unoccupied </div>
                <div className={s.unoccupiedString}>
                    {' '}
                    {open} to {close}{' '}
                </div>
                <hr />
            </React.Fragment>
        );
    };

    occupiedLocation = () => {
        const { name, openDate, closeDate } = this.props;
        const open = new Date(openDate).toDateString();
        const close = new Date(closeDate).toDateString();
        return (
            <React.Fragment>
                <div className={s.title}> {name} </div>
                <div className={s.occupiedDateContainer}>
                    {' '}
                    <span className={s.closed}> Closed </span> - {close}
                </div>
                <div className={s.occupiedDateContainer}>
                    {' '}
                    <span className={s.open}> Opened </span> - {open}
                </div>
                <hr />
            </React.Fragment>
        );
    };

    render() {
        const { unoccupied } = this.props;
        return <div className={s.occupancyDates}>{unoccupied ? this.unoccupiedLocation() : this.occupiedLocation()}</div>;
    }
}

export default OccupancyDates;
